import { connect } from "react-redux";
import get from "lodash/get";
import { bindActionCreators } from "redux";
import addHours from "date-fns/addHours";
import { useEffect } from "react";
import SmartDPSearchForm from "app/pages/SmartDP/Search/SDPSearchForm/SmartDPSearchForm";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import PropTypes from "prop-types";
import { getTopDestinations } from "app/reducers/shopSelector";

const SmartDPSearchFormContainer = props => {
	const { fetchSDPFilters } = props;

	useEffect(() => {
		fetchSDPFilters();
	}, []);

	return <SmartDPSearchForm {...props} />;
};

SmartDPSearchFormContainer.propTypes = {
	fetchSDPFilters: PropTypes.func,
};

const mapStateToProps = state => {
	const currentMerchCode = state.merchandising?.current?.code;

	// because there is a SmartDPsearchFormContainer is sdp/search and /merch pages, we need
	// to know from where we initialise the form
	const booking = currentMerchCode ? state.booking.smartDPMerch : state.booking;

	const initialValues = {
		travelDates: {},
	};

	if (get(state, "smartDP.cabins[0]")) {
		initialValues.cabin = get(state, "smartDP.cabins[0]");
	}

	if (booking.cabin?.code) {
		initialValues.cabin = booking.cabin;
	}

	if (booking.destinationResort?.code && state.smartDP.destinations) {
		const destination = state.smartDP.destinations.find(
			destination => destination.code.toString() === booking.destinationResort.code
		);
		if (destination) {
			initialValues.destinationResort = {
				...booking.destinationResort,
				departureDateStart: destination.departureDateStart,
				departureDateEnd: destination.departureDateEnd,
			};
		}
	}
	//
	if (booking.departureCity?.code) {
		initialValues.departureCity = booking.departureCity;
	}

	if (booking.departureDate) {
		// @see SmartDPSearch in handleFormSubmission
		// ex Paris : Fri Jun 11 2021 02:00:00 GMT+0200 (heure d’été d’Europe centrale)
		let departureDate = new Date(booking.departureDate);
		// => Fri Jun 11 2021 00:00:00 GMT+0200 (heure d’été d’Europe centrale)
		departureDate = addHours(departureDate, departureDate.getTimezoneOffset() / 60);
		// departureDate.geTime() gives 10/6/2021 à 22:00:00
		initialValues.travelDates.departureDate = departureDate;
	}

	if (booking.endDate) {
		// @see SmartDPSearch in handleFormSubmission
		// ex Paris : Fri Jun 11 2021 02:00:00 GMT+0200 (heure d’été d’Europe centrale)
		let endDate = new Date(booking.endDate);
		// => Fri Jun 11 2021 00:00:00 GMT+0200 (heure d’été d’Europe centrale)
		endDate = addHours(endDate, endDate.getTimezoneOffset() / 60);
		// endDate.geTime() gives 10/6/2021 à 22:00:00
		initialValues.travelDates.endDate = endDate;
	}

	if (booking.occupancies?.length > 0) {
		initialValues.occupancies = booking.occupancies;
	}

	if (booking.duration?.value) {
		initialValues.duration = {
			code: booking.duration.value,
		};
	}

	return {
		initialValues,
		destinations: state.smartDP.destinations,
		departureCities: state.smartDP.departureCities,
		cabins: state.smartDP.cabins,
		topDestinationsList: getTopDestinations(state) || [],
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPFilters,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDPSearchFormContainer);
